<template>
  <div>
    <v-app id="login" class="teal">
      <v-content>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex pa-1>
                <div size="30px">
                  <img
                    class="logo-login"
                    src="/static/avatar/logo.png"
                    alt="Avatar"
                  />
                </div>
              </v-flex>
              <v-flex pa-1>
                <v-card-actions class="pb-4">
                  <v-spacer></v-spacer>
                  <h3 class="proceso-titulo">
                    PROCESO {{ new Date().getFullYear() }}
                  </h3>
                </v-card-actions>
              </v-flex>
            </v-flex>
            <v-flex xs12>
              <v-layout align-center justify-center>
                <h2 class="titulo-login">
                  SISTEMA DE INFORMACIÓN DE GESTIÓN ADMINISTRATIVA SIMCE
                </h2>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg5>
            <v-card class="login-card elevation-12">
              <v-card-text>
                <div class="layout column align-center">
                  <h1 class="flex my-4 primary--text titulo">Acceso SIGAS</h1>
                </div>
              </v-card-text>
              <v-card-actions>
                <div class="container">
                  <div class="row">
                    <div class="column">
                      <div class="option">
                        <h2>Acceso Agencia</h2>
                        <p>Accede usando tu cuenta de Google.</p>
                        <div>
                          <div
                            id="g_id_onload"
                            data-client_id="568817530958-77f1ajhacftvre0e5n5vlj9nknnvo4am.apps.googleusercontent.com"
                            data-context="use"
                            data-ux_mode="popup"
                            data-callback="handleCredentialResponse"
                            data-auto_prompt="false"
                          ></div>
                          <div
                            class="g_id_signin"
                            data-type="standard"
                            data-shape="rectangular"
                            data-theme="filled_blue"
                            data-text="signin_with"
                            data-size="large"
                            data-logo_alignment="left"
                          ></div>
                          <template>
                            <div ref="googleLoginBtn" />
                          </template>
                        </div>
                      </div>
                    </div>
                    <div class="divider"></div>
                    <div class="column">
                      <div class="option">
                        <h2>Acceso Proveedores</h2>
                        <p>Accede usando tu Clave Única.</p>
                        <a
                          class="btn-cu btn-m btn-color-estandar"
                          href="#"
                          onclick="javascript:location.href='https://validadorclaveunica.agenciaeducacion.cl/Consulta'"
                        >
                          <span class="cl-claveunica"></span>
                          <span class="texto">ClaveÚnica</span>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "LoginNew",

  components: {},
  data() {
    return {
      client_id:
        "568817530958-77f1ajhacftvre0e5n5vlj9nknnvo4am.apps.googleusercontent.com",
    };
  },
  created() {},
  mounted() {
    google.accounts.id.initialize({
      client_id: this.client_id,
      callback: this.handleCredentialResponse,
    });

    google.accounts.id.renderButton(this.$refs.googleLoginBtn, {
      type: "standard",
      shape: "rectangular",
      text: "signup_with",
      size: "large",
      theme: "filled_blue",
      logo_alignment: "left",
    });
  },

  methods: {
    async handleCredentialResponse(response) {
      axios
        .post("/valida/google", response)
        .then((response) => {
          //  console.log("response:" + JSON.stringify(response, null, 2));
          if (response && response != null && response.data) {
            this.$store
              .dispatch("loginExterno", { response })
              .then(() => {
                // Navega a la pagina "ProveedorImpresion" despues de la autenticacion exitosa
                this.$router
                  .push({ name: "ProveedorImpresion" })
                  .catch((err1) => {
                    console.log("catch loginGoogle load:" + err1);
                  });
              })
              .catch((err) => {
                // Maneja errores de autenticacion
                console.log(
                  "error loginGoogle catch dispatch google:" +
                    JSON.stringify(err, null, 2)
                );
              });
          } else {
            //no existe usuario en BD???
            window.getApp.$emit("APP_UNAUTHORIZED");
            this.$router.push({ name: "LoginNew" }).catch((err1) => {
              console.log("catch loginGoogle user no existe?:" + err1);
            });
          }
        })
        .catch((error) => {
          // Maneja errores de la solicitud de validacion de Google
          console.log(
            "st::error login google:" + JSON.stringify(error, null, 2)
          );
        });
    },
  },
};
</script>

<style scoped lang="css">
#login {
  height: 58%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
.primary--text {
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
}
.v-label--active .primary--text {
  color: #3f51b5 !important;
  caret-color: #3f51b5 !important;
}

/* new */
.container {
  display: flex;
  justify-content: center;
}

.row {
  display: flex;
  justify-content: center;
  width: 100%;
}

.column {
  flex: 1;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center; /* Centrar horizontalmente el contenido */
}

.divider {
  border-left: 1px solid #ccc;
  height: 100%;
  margin: 20px 10px; /* ajuste de margen para la línea */
}

.option {
  margin-top: 20px;
}

.cl-claveunica-logo {
  display: inline-block;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
}
.btn-cu.btn-color-estandar {
  background-color: #0f69c4;
  color: #fff;
}
.btn-cu.btn-color-estandar:hover {
  background-color: #0c549c;
  color: #fff;
}
.btn-cu.btn-color-estandar:active {
  background-color: #093f75;
  color: #fff;
}
.btn-cu.btn-color-estandar:focus {
  background-color: #0c549c;
  color: #fff;
  outline: 1px dashed #000;
}

/* Boton estilo de base */
.btn-cu {
  display: inline-block;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border-radius: 0;
}
/*Icono ClaveÚnica*/
.btn-cu .cl-claveunica {
  display: inline;
  float: left;
  text-indent: -9999px;
}
/*Texto ClaveÚnica*/
.btn-cu .texto {
  padding-left: 3px;
  text-decoration: underline;
}
/* Tamaño M */
.btn-cu.btn-m {
  width: 250px;
  min-width: 250px;
  max-height: 42px;
  padding: 8px 18px 8px 15px !important;
  font-size: 16px;
  line-height: 1.6em;
}
.btn-cu.btn-m .cl-claveunica {
  display: inline-block;
  width: 24px;
  height: 24px;
  background-size: 24px 24px;
  /* background-image: "/static/icon/claveunica.svg"; */
  background: url(/static/icon/clave_unica_24px.svg);
}
</style>
